import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import { type RootState } from '@redux/store';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx';
import { H2 } from '@/components/Typography/Typography';

import StepPlantCard from './StepPlantCard';

const AdditionalInformation: React.FC = () => {
  const { user, extendedInfo } = useSelector((state: RootState) => state.user);
  const { t } = useTranslation();

  const calculateDaysDifference = (
    createdAt: string,
    lastVisited: string,
  ): number => {
    if (createdAt === lastVisited) {
      return 0;
    }
    const createdDate = new Date(createdAt);
    const lastVisitedDate = new Date(lastVisited);

    const differenceInMs = lastVisitedDate.getTime() - createdDate.getTime();

    return Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
  };

  const stepPlantsNextLevel = extendedInfo?.stepPlantsNextLevel;

  return (
    extendedInfo &&
    stepPlantsNextLevel && (
      <div>
        <div className="additionalInformation-moreInfo">
          <div className="additionalInformation-moreInfo-block">
            <span>{t('In-game days')}</span>
            <div>
              <picture>
                <source srcSet="/img/icons/timer.webp" type="image/webp" />
                <img
                  src="/img/icons/timer.png"
                  alt="icon"
                  width={convertRemToPixels(2)}
                />
              </picture>
              <p>
                {user &&
                  toShortNumFormat(
                    calculateDaysDifference(user.createdAt, user.lastVisited),
                  )}
              </p>
            </div>
          </div>
        </div>
        <div className="nextLevel-steps">
          {user && <H2>{t('Steps to Level') + ' ' + (user.level + 1)}</H2>}
          {stepPlantsNextLevel.map((el) => (
            <StepPlantCard {...el} />
          ))}
        </div>
      </div>
    )
  );
};

export default AdditionalInformation;
